<link class="skin" rel="stylesheet" type="text/css" href="/assets/css/skin/skin-1.css">
<app-header-one [data]="menuList"></app-header-one>
<app-page-header-one [data] = "banner"></app-page-header-one>
<app-contact-form></app-contact-form>
<app-contact-map></app-contact-map>
<app-footer-one></app-footer-one>
